import { parseEther, readContract, writeContractAndWait, zeroAddress } from "../viem";
import { approveToken, getTokenAllowance } from ".";

import OgCrateMinterABI from "../../abis/OGCrateMinter.json";

import config from "../../config/config";
import { delay } from "../../utils/utils";
import { SwapToken } from "./../../types/Contract/SwapToken";
import { isIndexingTxError } from "../parseTxError";

const address = config.crateMinterAddress;
const abi = OgCrateMinterABI;

export const getSwapTokens = async () => {
  const swapTokenInfo: [SwapToken[], number[]] = await readContract({
    address,
    abi,
    functionName: "getSwapTokens",
  });

  return swapTokenInfo;
};

export const buyCrates = async (
  swapTokenId: number,
  tokenAddress: string,
  tokenAmount: number,
  crateAmount: number,
  account: string
) => {
  if (tokenAddress === zeroAddress) {
    const nativeAmount = parseEther(tokenAmount.toFixed(18));

    await writeContractAndWait({
      address,
      abi,
      functionName: "buyCrates",
      args: [swapTokenId, crateAmount],
      account,
      value: nativeAmount,
    });
  } else {
    const tokenAllowance = await getTokenAllowance(
      tokenAddress,
      account,
      config.crateMinterAddress
    );
    try {
      if (Number(tokenAllowance) < tokenAmount) {
        await approveToken(
          tokenAddress,
          tokenAmount,
          config.crateMinterAddress,
          account
        );

        await delay(config.blockTime);
      }
    } catch (error: any) {
      if (isIndexingTxError(error)) {
        await delay(config.blockTime);
      } else {
        throw error;
      }
    }

    await writeContractAndWait({
      address,
      abi,
      functionName: "buyCrates",
      args: [swapTokenId, crateAmount],
      account,
    });
  }
};
